import React from 'react'
import PropTypes from 'prop-types'

import AppLogo from '../../../features/components/AppLogo'

import useStyles from './styles'

function AppLoader({ showTopMenu, showSideMenu }) {
  const classes = useStyles({ showTopMenu, showSideMenu })

  return (
    <div className={classes.screensaver}>
      <AppLogo />
    </div>
  )
}

AppLoader.propTypes = {
  showTopMenu: PropTypes.bool,
  showSideMenu: PropTypes.bool
}

export default AppLoader
